// Store
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  parametersArray: [],
};

const parametersSlice = createSlice({
  name: 'parameters',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },

    /**
     * Replaces all the parameters of one device with a freshly built batch.
     *
     * Descriptors carry a stable `uid` (device + paramKey + channel/ma/pump
     * qualifiers), so replacing the device's whole batch at once both updates
     * the existing cards and drops stale ones — no per-title deduplication
     * is needed. Parameters of other devices are kept untouched.
     */
    setDeviceParameters: (state, action) => {
      const { deviceId, parameters } = action.payload;

      const otherDevicesParams = state.parametersArray.filter(
        (param) => param.device.id !== deviceId,
      );

      state.parametersArray = [...otherDevicesParams, ...parameters].sort(
        (a, b) => a.device.id - b.device.id,
      );
    },
  },
});

export const { resetState, setDeviceParameters } = parametersSlice.actions;

export default parametersSlice;
